import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PerfilesService {

  baserApiUrl:string=environment.baseApi
  constructor(public http:HttpClient) { }
  

  getPerfiles(filter:any){
    return this.http.get(`${this.baserApiUrl}perfiles?${filter}`)
  }

}
